<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-links">
        <router-link to="/terms-of-service" class="footer-link">{{ $t('footer.termsOfService') }}</router-link>
        <router-link to="/privacy-policy" class="footer-link">{{ $t('footer.privacyPolicy') }}</router-link>
        <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer" class="footer-link">{{ $t('footer.youtubeTerms') }}</a>
        <a href="http://www.google.com/policies/privacy" target="_blank" rel="noopener noreferrer" class="footer-link">{{ $t('footer.googlePrivacy') }}</a>
      </div>
      <div class="footer-info">
        <p>{{ $t('footer.copyright') }}</p>
        <p>{{ $t('footer.youtubeApiNotice') }}</p>
        <p class="company-info">
          {{ $t('footer.madeBy') }} <a href="https://www.bactory.co.kr" target="_blank" rel="noopener noreferrer" class="company-link">백토리(Bactory)</a>
        </p>
        <p>{{ $t('footer.contact') }} <a href="mailto:master@ttaechang.com" class="email-link">master@ttaechang.com</a></p>
      </div>
    </div>
  </footer>
</template>

<script setup>
// 공통 푸터 컴포넌트
</script>

<style scoped>
.app-footer {
  background: rgba(0, 0, 0, 0.9);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 2rem 0;
  margin-top: auto;
  color: rgba(255, 255, 255, 0.8);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  text-align: center;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.footer-link {
  color: #4ecdc4;
  text-decoration: none;
  font-size: 0.9rem;
  padding: 0.5rem 0;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #61dafb;
  text-decoration: underline;
}

.footer-info {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
}

.footer-info p {
  margin: 0.3rem 0;
}

.company-link,
.email-link {
  color: #4ecdc4;
  text-decoration: none;
  transition: color 0.3s ease;
}

.company-link:hover,
.email-link:hover {
  color: #61dafb;
  text-decoration: underline;
}

/* 반응형 푸터 */
@media (max-width: 768px) {
  .footer-links {
    flex-direction: column;
    gap: 1rem;
  }

  .footer-content {
    padding: 0 1rem;
  }

  .app-footer {
    padding: 1.5rem 0;
  }
}
</style>